import React, { Component } from 'react';
import PokemonWrapper from '../components/PokemonWrapper';
import SearchBox from '../components/SearchBox';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Scroll from '../components/Scroll';
import ErrorBoundary from './ErrorBoundary';
import { pokemons } from '../inc/pokemons';

class App extends Component {
	constructor() {
		super();
		this.state = {
			searchfield: '',
		}
	}

	grabSearchInput = (event) => {
		return this.setState({ searchfield: event.target.value });
	}

	render() {
		const filteredPokemon = pokemons.filter(data => {
			return data.name.toLowerCase().includes(this.state.searchfield.toLowerCase());
		}) 

		return (
			<div id="main-wrapper">
				<div className='pokemon-section-wrapper'>
					<Header>
						<h1>Pokédex</h1>
						<SearchBox grab_input={this.grabSearchInput} />
					</Header>
					<Scroll>
						<ErrorBoundary>
							<PokemonWrapper pokemons={filteredPokemon} />
						</ErrorBoundary>
					</Scroll>
				</div>
				<Footer />
			</div>
		);
	}
}

export default App;


// WEBPACK FOOTER //
// ./src/containers/App.js